import React, { FC } from 'react'
import classNames from 'classnames'
import { AsH3, HeadingXS } from '@/atoms/Text'
import { Accordion, AccordionItem } from '@/molecules/Accordion'
import { Faq } from '@/types/codegen-federation'
import { useTranslate } from '@/utils/translate/translate-client'
import { PifSectionTitle } from './PifSectionTitle'

interface ViewProps {
  faqs: Faq[]
  className?: string
  newPifLayout?: boolean
}

export const TheatricalPifFaq: FC<ViewProps> = ({ className, faqs, newPifLayout }) => {
  const { t } = useTranslate('pif')

  return (
    <div className={className}>
      <div className={classNames('border-b', newPifLayout ? 'border-transparent' : 'border-core-gray-300')}>
        {newPifLayout ? (
          <PifSectionTitle className="mb-4 block md:mb-6">
            {t('frequentlyAskedQuestions', 'Frequently Asked Questions')}
          </PifSectionTitle>
        ) : (
          <HeadingXS as={AsH3} className="mb-3 text-2xl tracking-tight text-core-gray-950" weight="bold">
            {t('frequentlyAskedQuestions', 'Frequently Asked Questions')}
          </HeadingXS>
        )}
        <Accordion>
          {faqs?.map((faq: Faq, index: number) => (
            <AccordionItem
              labelClassName={classNames(
                'w-full m-0 p-0 text-black',
                newPifLayout
                  ? '!photon-title-sm !text-lg !font-semibold'
                  : 'text-lg font-bold text-2xl !leading-[1.25] font-angelSans m-0 p-0',
              )}
              showTopBorder={!newPifLayout}
              label={faq.question}
              key={faq.question}
              borderColor={'core-gray-300'}
              contentClassName="!text-core-gray-700 !photon-paragraph-md !leading-7"
              defaultOpen={index === 0}
              triggerClassName={newPifLayout ? '!pb-2' : 'pb-4'}
            >
              <div dangerouslySetInnerHTML={{ __html: faq.answer as string }} />
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  )
}
